export type TabType = string;
export type TabStatus = "dev" | "production";

export const TAB_TYPE_SUGGESTIONS: { value: string; label: string }[] = [
  { value: "services", label: "Сервисы" },
  { value: "feed", label: "Лента" },
  { value: "chats", label: "Чаты" },
  { value: "profile", label: "Профиль" },
];

export const TAB_STATUSES: { value: TabStatus; label: string }[] = [
  { value: "dev", label: "Dev" },
  { value: "production", label: "Production" },
];

export type Tab = {
  id: string;
  mini_app_id: string;
  title: string;
  type: TabType;
  status: TabStatus;
  created_at: string;
  updated_at: string;
};

export type TabsResponseType = {
  data: Tab[];
  page: number;
  size: number;
  sort: string;
  total: number;
};

export type CreateTabPayload = {
  mini_app_id?: string | null;
  type: TabType;
  status: TabStatus;
  title: string;
};

export type UpdateTabPayload = {
  mini_app_id?: string | null;
  type?: TabType;
  status?: TabStatus;
  title?: string;
};

export const emptyTabsResponse: TabsResponseType = {
  data: [],
  page: 0,
  size: 0,
  sort: "",
  total: 0,
};
